module.exports = __webpack_public_path__ + "img/1586062777.9a295065.jpg";